import { Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import GridKeikkaEditor_Teksti_Row from "../../teksti/GridKeikkaEditor_Teksti_Row";
import { Directions } from "@mui/icons-material";
import { kloString, pvmStringLong } from "src/components/js/statics1";

export default function GridKeikkaEditor_Teksti_Toimitus({ subText, keikkaState }) {
  return (
    <GridKeikkaEditor_Teksti_Row
      title="Toimitus"
      right={
        <div className="spaceBetween">
          <div>
            {keikkaState?.betoniSijaintiNimi} -&gt; {keikkaState?.tyomaaOsoite1}
            {keikkaState?.betoniMatkaM > 0 &&
              subText(
                (keikkaState?.betoniMatkaM / 1000).toFixed(1) +
                  " km " +
                  keikkaState?.betoniMatkaAika +
                  " min"
              )}
          </div>
          <Button
            tabIndex={-1}
            disabled={keikkaState?.tyomaaId == 0}
            variant="outlined"
            onClick={() => {
              // navigate to google maps address
              window.open(
                "https://www.google.com/maps/search/?api=1&query=" + keikkaState?.tyomaaOsoite,
                "_blank"
              );
            }}>
            <Directions />
          </Button>
        </div>
      }>
      <Typography variant="h6" color="primary">
        {subText(
          pvmStringLong(keikkaState?.timeStart) +
            " " +
            kloString(keikkaState?.timeStart) +
            "-" +
            kloString(keikkaState?.timeEnd)
        )}
      </Typography>
      {subText(keikkaState?.keikkaTilaSelite)}
    </GridKeikkaEditor_Teksti_Row>
  );
}

GridKeikkaEditor_Teksti_Toimitus.propTypes = {
  subText: PropTypes.func,
  keikkaState: PropTypes.object,
};
